var items = {
  "block.minecraft.air": "aihr",
  "block.minecraft.stone": "rock",
  "block.minecraft.granite": "red rock",
  "block.minecraft.polished_granite": "pretteh red rock",
  "block.minecraft.diorite": "kitteh litter rockz",
  "block.minecraft.polished_diorite": "pretteh kitteh litter rockz",
  "block.minecraft.andesite": "grey rock",
  "block.minecraft.polished_andesite": "pretteh grey rock",
  "block.minecraft.grass_block": "gras blak",
  "block.minecraft.dirt": "durt",
  "block.minecraft.coarse_dirt": "ruff durt",
  "block.minecraft.podzol": "durtee durt",
  "block.minecraft.crimson_nylium": "crimzun nyanium",
  "block.minecraft.warped_nylium": "wrped nyanium",
  "block.minecraft.cobblestone": "cooblestoneh",
  "block.minecraft.oak_planks": "oak bloc",
  "block.minecraft.spruce_planks": "dark wooden bloc",
  "block.minecraft.birch_planks": "lite woodezn blox",
  "block.minecraft.jungle_planks": "junglz wodden bloc",
  "block.minecraft.acacia_planks": "acashuh plankz",
  "block.minecraft.dark_oak_planks": "oranj wud",
  "block.minecraft.crimson_planks": "crimsun planmks",
  "block.minecraft.warped_planks": "warpt plaenkz",
  "block.minecraft.oak_sapling": "baby oak",
  "block.minecraft.spruce_sapling": "baby spurce",
  "block.minecraft.birch_sapling": "baby burch",
  "block.minecraft.jungle_sapling": "baby jungel",
  "block.minecraft.acacia_sapling": "baby acashuh",
  "block.minecraft.dark_oak_sapling": "baby blak oak",
  "block.minecraft.bedrock": "trol blukz",
  "block.minecraft.sand": "litter box stuffs",
  "block.minecraft.red_sand": "red sand",
  "block.minecraft.gravel": "graval",
  "block.minecraft.gold_ore": "rockz wif guld",
  "block.minecraft.iron_ore": "rockz wif irun",
  "block.minecraft.coal_ore": "rockz wif coel",
  "block.minecraft.nether_gold_ore": "netherockz wif guld",
  "block.minecraft.oak_log": "oak lawg",
  "block.minecraft.spruce_log": "spruce lawg",
  "block.minecraft.birch_log": "lite woodezn lawg",
  "block.minecraft.jungle_log": "junglz wodden lawg",
  "block.minecraft.acacia_log": "acashuh lawg",
  "block.minecraft.dark_oak_log": "oranj lawg",
  "block.minecraft.crimson_stem": "crimzn stim",
  "block.minecraft.warped_stem": "warpt trunkk",
  "block.minecraft.stripped_oak_log": "naked oac lawg",
  "block.minecraft.stripped_spruce_log": "naked spruice lawg",
  "block.minecraft.stripped_birch_log": "naked berch lawg",
  "block.minecraft.stripped_jungle_log": "naked juncle lawg",
  "block.minecraft.stripped_acacia_log": "naked acashuh lawg",
  "block.minecraft.stripped_dark_oak_log": "naked shaded-o lawg",
  "block.minecraft.stripped_crimson_stem": "nakd crimzon stem",
  "block.minecraft.stripped_warped_stem": "naekt warpt stem",
  "block.minecraft.stripped_oak_wood": "naked oac bawk",
  "block.minecraft.stripped_spruce_wood": "naked sproos bawk",
  "block.minecraft.stripped_birch_wood": "naked berch bawk",
  "block.minecraft.stripped_jungle_wood": "naked juggle bawk",
  "block.minecraft.stripped_acacia_wood": "naked acashuh bawk",
  "block.minecraft.stripped_dark_oak_wood": "naked blak oac bawk",
  "block.minecraft.stripped_crimson_hyphae": "da werd red nehtr plnta but neked",
  "block.minecraft.stripped_warped_hyphae": "da werd nethr plnt butt nakie",
  "block.minecraft.oak_wood": "oak wuud",
  "block.minecraft.spruce_wood": "spruz wuud",
  "block.minecraft.birch_wood": "birtch wuud",
  "block.minecraft.jungle_wood": "jungl wuud",
  "block.minecraft.acacia_wood": "acashuh wuud",
  "block.minecraft.dark_oak_wood": "dark oak wuud",
  "block.minecraft.crimson_hyphae": "weerd red nethar plnat",
  "block.minecraft.warped_hyphae": "wierd nethr plant",
  "block.minecraft.oak_leaves": "oak salad",
  "block.minecraft.spruce_leaves": "spruce salad",
  "block.minecraft.birch_leaves": "birch salad",
  "block.minecraft.jungle_leaves": "jungel salad",
  "block.minecraft.acacia_leaves": "savana lefs",
  "block.minecraft.dark_oak_leaves": "derk ok lefs",
  "block.minecraft.sponge": "spangblob",
  "block.minecraft.wet_sponge": "wet spangblob",
  "block.minecraft.glass": "glazz",
  "block.minecraft.lapis_ore": "rockz wif blu stuf",
  "block.minecraft.lapis_block": "comppressed lelazululi",
  "block.minecraft.dispenser": "dizpnzur",
  "block.minecraft.sandstone": "litter box rockz",
  "block.minecraft.chiseled_sandstone": "carved litter box rockz",
  "block.minecraft.cut_sandstone": "warmy sanstown",
  "block.minecraft.note_block": "nowht blohk",
  "block.minecraft.powered_rail": "puwerd rail",
  "block.minecraft.detector_rail": "ditektar ral",
  "block.minecraft.sticky_piston": "stickeh pushurr",
  "block.minecraft.cobweb": "icky spider webz",
  "block.minecraft.grass": "grazz",
  "block.minecraft.fern": "furn",
  "block.minecraft.dead_bush": "died bushez",
  "block.minecraft.seagrass": "marin grazz",
  "block.minecraft.sea_pickle": "see pikol",
  "block.minecraft.piston": "pushur",
  "block.minecraft.white_wool": "waite fur bluk",
  "block.minecraft.orange_wool": "ornge fur bluk",
  "block.minecraft.magenta_wool": "majenta fur bluk",
  "block.minecraft.light_blue_wool": "lite bloo fur bluk",
  "block.minecraft.yellow_wool": "yello fur bluk",
  "block.minecraft.lime_wool": "limd fur bluk",
  "block.minecraft.pink_wool": "pinky fur bluk",
  "block.minecraft.gray_wool": "gray fur bluk",
  "block.minecraft.light_gray_wool": "lite gray fur bluk",
  "block.minecraft.cyan_wool": "sighun fur bluk",
  "block.minecraft.purple_wool": "parpal fur bluk",
  "block.minecraft.blue_wool": "bloo fur bluk",
  "block.minecraft.brown_wool": "brownish fur bluk",
  "block.minecraft.green_wool": "greenish fur bluk",
  "block.minecraft.red_wool": "redish fur bluk",
  "block.minecraft.black_wool": "black fur bluk",
  "block.minecraft.dandelion": "yello flowah",
  "block.minecraft.poppy": "poopy",
  "block.minecraft.blue_orchid": "pretteh bloo flowr",
  "block.minecraft.allium": "alollium",
  "block.minecraft.azure_bluet": "bloo flowre",
  "block.minecraft.red_tulip": "red tulehp",
  "block.minecraft.orange_tulip": "ornge tulehp",
  "block.minecraft.white_tulip": "wite tulehp",
  "block.minecraft.pink_tulip": "pink tulehp",
  "block.minecraft.oxeye_daisy": "big wite flowr",
  "block.minecraft.cornflower": "unicornflowerpower",
  "block.minecraft.lily_of_the_valley": "lily of da vallyz",
  "block.minecraft.wither_rose": "wither roos",
  "block.minecraft.brown_mushroom": "brwn mushroom",
  "block.minecraft.red_mushroom": "blood mooshroom",
  "block.minecraft.crimson_fungus": "crimzn foongis",
  "block.minecraft.warped_fungus": "warpt foongis",
  "block.minecraft.crimson_roots": "crimsun roots",
  "block.minecraft.warped_roots": "warpt roods",
  "block.minecraft.nether_sprouts": "hall sprowts",
  "block.minecraft.weeping_vines": "oh no y u cry roof noddle",
  "block.minecraft.twisting_vines": "spyrale noodel",
  "block.minecraft.sugar_cane": "bambooo",
  "block.minecraft.kelp": "yucky lettuce",
  "block.minecraft.bamboo": "green stick",
  "block.minecraft.gold_block": "shiny blok",
  "block.minecraft.iron_block": "blok of irony",
  "block.minecraft.oak_slab": "oak sleb",
  "block.minecraft.spruce_slab": "sproos sleb",
  "block.minecraft.birch_slab": "burch sleb",
  "block.minecraft.jungle_slab": "jungo sleb",
  "block.minecraft.acacia_slab": "akacia sleb",
  "block.minecraft.dark_oak_slab": "blak oke sleb",
  "block.minecraft.crimson_slab": "crimzn sleb",
  "block.minecraft.warped_slab": "warpt slaep",
  "block.minecraft.stone_slab": "stne slab",
  "block.minecraft.smooth_stone_slab": "smooth ston sleb",
  "block.minecraft.sandstone_slab": "sansdstoen sleb",
  "block.minecraft.cut_sandstone_slab": "cut sansdstoen sleb",
  "block.minecraft.petrified_oak_slab": "petrifid oak sleb",
  "block.minecraft.cobblestone_slab": "small pebble blok",
  "block.minecraft.brick_slab": "brik sleb",
  "block.minecraft.stone_brick_slab": "ston brick sleb",
  "block.minecraft.nether_brick_slab": "nether brik slav",
  "block.minecraft.quartz_slab": "white half blok",
  "block.minecraft.red_sandstone_slab": "rds litterbox slab",
  "block.minecraft.cut_red_sandstone_slab": "cut warmy sansdstoen sleb",
  "block.minecraft.purpur_slab": "ooo purpur bluk cut in half",
  "block.minecraft.prismarine_slab": "prizmarine sleb",
  "block.minecraft.prismarine_brick_slab": "blue sleb thing",
  "block.minecraft.dark_prismarine_slab": "dark prizmarine sleb",
  "block.minecraft.smooth_quartz": "smooth wite kat blawk",
  "block.minecraft.smooth_red_sandstone": "smud warmy sanstown",
  "block.minecraft.smooth_sandstone": "smooth litter box rockz",
  "block.minecraft.smooth_stone": "smooth rockz",
  "block.minecraft.bricks": "brickz",
  "block.minecraft.tnt": "boom",
  "block.minecraft.bookshelf": "bed 4 bookz",
  "block.minecraft.mossy_cobblestone": "durty cobulstown",
  "block.minecraft.obsidian": "hardest thing evar",
  "block.minecraft.torch": "burny stick",
  "block.minecraft.end_rod": "unikorn horn",
  "block.minecraft.chorus_plant": "meow plantz",
  "block.minecraft.chorus_flower": "meow flawur",
  "block.minecraft.purpur_block": "ooo purpur bluk",
  "block.minecraft.purpur_pillar": "ooo purpur bluk w/ stripez",
  "block.minecraft.purpur_stairs": "ooo purpur bluk u can climb",
  "block.minecraft.spawner": "spaawnr",
  "block.minecraft.oak_stairs": "woakoak stairz",
  "block.minecraft.chest": "cat box",
  "block.minecraft.diamond_ore": "rockz wif deemond",
  "block.minecraft.diamond_block": "much muny $$$",
  "block.minecraft.crafting_table": "krafting tabal",
  "block.minecraft.farmland": "fudholz",
  "block.minecraft.furnace": "hot box",
  "block.minecraft.ladder": "ladr",
  "block.minecraft.rail": "trakz",
  "block.minecraft.cobblestone_stairs": "rok stairz",
  "block.minecraft.lever": "flipurr",
  "block.minecraft.stone_pressure_plate": "stone presar plat",
  "block.minecraft.oak_pressure_plate": "oak prseure pleitz",
  "block.minecraft.spruce_pressure_plate": "sproos prseure pleitz",
  "block.minecraft.birch_pressure_plate": "burch prseure pleitz",
  "block.minecraft.jungle_pressure_plate": "jongle prseure pleitz",
  "block.minecraft.acacia_pressure_plate": "akacia prseure pleitz",
  "block.minecraft.dark_oak_pressure_plate": "dark oke prseure pleitz",
  "block.minecraft.crimson_pressure_plate": "crimson prseure pleitz",
  "block.minecraft.warped_pressure_plate": "wapt weight plaet",
  "block.minecraft.polished_blackstone_pressure_plate": "shiny blak rok step button",
  "block.minecraft.redstone_ore": "rockz wif redstone",
  "block.minecraft.redstone_torch": "glowy redstone stik",
  "block.minecraft.snow": "cold white stuff",
  "block.minecraft.ice": "frozen water",
  "block.minecraft.snow_block": "snowi bloc",
  "block.minecraft.cactus": "spiky green plant",
  "block.minecraft.clay": "clae",
  "block.minecraft.jukebox": "catbox",
  "block.minecraft.oak_fence": "oke fenz",
  "block.minecraft.spruce_fence": "sprce fenc",
  "block.minecraft.birch_fence": "birch scratchezpost",
  "block.minecraft.jungle_fence": "janggal fence",
  "block.minecraft.acacia_fence": "cat fence",
  "block.minecraft.dark_oak_fence": "drk oak fence",
  "block.minecraft.crimson_fence": "crimzn fanse",
  "block.minecraft.warped_fence": "warpt fenc",
  "block.minecraft.pumpkin": "pangkan",
  "block.minecraft.carved_pumpkin": "karvd pumpkin",
  "block.minecraft.netherrack": "netherrack",
  "block.minecraft.soul_sand": "sole snd",
  "block.minecraft.soul_soil": "ded peeple dirt",
  "block.minecraft.basalt": "bawzult",
  "block.minecraft.polished_basalt": "cleened baisolt",
  "block.minecraft.soul_torch": "creepy torch thingy",
  "block.minecraft.glowstone": "glowstone",
  "block.minecraft.jack_o_lantern": "big glowy squash",
  "block.minecraft.oak_trapdoor": "oak trap",
  "block.minecraft.spruce_trapdoor": "sproos trap",
  "block.minecraft.birch_trapdoor": "burch trap",
  "block.minecraft.jungle_trapdoor": "jongle trap",
  "block.minecraft.acacia_trapdoor": "akacia trap",
  "block.minecraft.dark_oak_trapdoor": "blak oke trap",
  "block.minecraft.crimson_trapdoor": "crimzn kat door",
  "block.minecraft.warped_trapdoor": "warpt kat door",
  "block.minecraft.infested_stone": "invezzted stoon",
  "block.minecraft.infested_cobblestone": "invezzted cooblestoon",
  "block.minecraft.infested_stone_bricks": "rockz wit patternz and monsters",
  "block.minecraft.infested_mossy_stone_bricks": "rockz wit mozs and monsters",
  "block.minecraft.infested_cracked_stone_bricks": "brokin rockz wit monsters",
  "block.minecraft.infested_chiseled_stone_bricks": "kewl rockz wit monsters",
  "block.minecraft.stone_bricks": "stackd rockz",
  "block.minecraft.mossy_stone_bricks": "stacked greenish rockz",
  "block.minecraft.cracked_stone_bricks": "stacked pebblez",
  "block.minecraft.chiseled_stone_bricks": "stacked rockz en an patternz",
  "block.minecraft.brown_mushroom_block": "brwn mushroom blok",
  "block.minecraft.red_mushroom_block": "blood mushroom blok",
  "block.minecraft.mushroom_stem": "mushroom stem",
  "block.minecraft.iron_bars": "jeil bahz",
  "block.minecraft.chain": "shain",
  "block.minecraft.glass_pane": "glazz payn",
  "block.minecraft.melon": "mlon",
  "block.minecraft.vine": "climbin plantz",
  "block.minecraft.oak_fence_gate": "oke wod fence gate",
  "block.minecraft.spruce_fence_gate": "sprce fenc gaet",
  "block.minecraft.birch_fence_gate": "burch gait",
  "block.minecraft.jungle_fence_gate": "janggal fence gate",
  "block.minecraft.acacia_fence_gate": "acaisha gait",
  "block.minecraft.dark_oak_fence_gate": "dark gait",
  "block.minecraft.crimson_fence_gate": "crimzn fenc gaet",
  "block.minecraft.warped_fence_gate": "warpt fenc gaet",
  "block.minecraft.brick_stairs": "brik stairez",
  "block.minecraft.stone_brick_stairs": "stone brik sters",
  "block.minecraft.mycelium": "miceliwm",
  "block.minecraft.lily_pad": "big watr leef",
  "block.minecraft.nether_bricks": "brik from hell",
  "block.minecraft.cracked_nether_bricks": "craked nether brickz",
  "block.minecraft.chiseled_nether_bricks": "chizald nether brickz",
  "block.minecraft.nether_brick_fence": "nether brik fens",
  "block.minecraft.nether_brick_stairs": "nether brik sters",
  "block.minecraft.enchanting_table": "kewl tabel",
  "block.minecraft.end_portal_frame": "magik portl fraem",
  "block.minecraft.end_stone": "weird white rock",
  "block.minecraft.end_stone_bricks": "kat litter briks",
  "block.minecraft.dragon_egg": "dwagon eg",
  "block.minecraft.redstone_lamp": "redstone lapm",
  "block.minecraft.sandstone_stairs": "sanston sters",
  "block.minecraft.emerald_ore": "rockz wif emmiez",
  "block.minecraft.ender_chest": "endur chest",
  "block.minecraft.tripwire_hook": "string huk",
  "block.minecraft.emerald_block": "shineh bloock of green stuff",
  "block.minecraft.spruce_stairs": "sproos stairz",
  "block.minecraft.birch_stairs": "burch stairz",
  "block.minecraft.jungle_stairs": "junggel stairz",
  "block.minecraft.crimson_stairs": "crimzn staez",
  "block.minecraft.warped_stairs": "worp katstairs",
  "block.minecraft.command_block": "comnd bluk",
  "block.minecraft.beacon": "bacon",
  "block.minecraft.cobblestone_wall": "cobulstown wall",
  "block.minecraft.mossy_cobblestone_wall": "durty cobulstown wall",
  "block.minecraft.brick_wall": "brik wal",
  "block.minecraft.prismarine_wall": "prizmarine wal",
  "block.minecraft.red_sandstone_wall": "redy sandston wal",
  "block.minecraft.mossy_stone_brick_wall": "mossy ston brik wal",
  "block.minecraft.granite_wall": "red rock wal",
  "block.minecraft.stone_brick_wall": "ston brik wal",
  "block.minecraft.nether_brick_wall": "nether brik wal",
  "block.minecraft.andesite_wall": "grey rock wal",
  "block.minecraft.red_nether_brick_wall": "red nether brik wal",
  "block.minecraft.sandstone_wall": "sandston wal",
  "block.minecraft.end_stone_brick_wall": "ston brik wal of za end",
  "block.minecraft.diorite_wall": "diorito wal",
  "block.minecraft.blackstone_wall": "bleckston wal",
  "block.minecraft.polished_blackstone_wall": "shiny blak rok wal",
  "block.minecraft.polished_blackstone_brick_wall": "polised bleck brik wal",
  "block.minecraft.stone_button": "stoon button",
  "block.minecraft.oak_button": "oak button",
  "block.minecraft.spruce_button": "sproos button",
  "block.minecraft.birch_button": "burch button",
  "block.minecraft.jungle_button": "jongle button",
  "block.minecraft.acacia_button": "akacia button",
  "block.minecraft.dark_oak_button": "blak oke button",
  "block.minecraft.crimson_button": "crimzn bawttn",
  "block.minecraft.warped_button": "warpt thingy",
  "block.minecraft.polished_blackstone_button": "shiny blak rok buton",
  "block.minecraft.anvil": "anvehl",
  "block.minecraft.chipped_anvil": "oh so much chipped anvehl",
  "block.minecraft.damaged_anvil": "oh so much braken anvehl",
  "block.minecraft.trapped_chest": "rigged cat box",
  "block.minecraft.light_weighted_pressure_plate": "liht weightefd prueusure platt",
  "block.minecraft.heavy_weighted_pressure_plate": "hvy weited presplat plet",
  "block.minecraft.daylight_detector": "light eater",
  "block.minecraft.redstone_block": "redstone bluk",
  "block.minecraft.nether_quartz_ore": "nether kworts ore",
  "block.minecraft.hopper": "huperr",
  "block.minecraft.chiseled_quartz_block": "chizald kworts blak",
  "block.minecraft.quartz_block": "blak av kworts",
  "block.minecraft.quartz_bricks": "kwartz brickz",
  "block.minecraft.quartz_pillar": "kwartz piler",
  "block.minecraft.quartz_stairs": "kworts sters",
  "block.minecraft.activator_rail": "powaaaaaaaaaaah",
  "block.minecraft.dropper": "drupper",
  "block.minecraft.white_terracotta": "waite terrakattah",
  "block.minecraft.orange_terracotta": "orang teracottah",
  "block.minecraft.magenta_terracotta": "majenta teracottah",
  "block.minecraft.light_blue_terracotta": "lite blu teracottah",
  "block.minecraft.yellow_terracotta": "yollo terrakattah",
  "block.minecraft.lime_terracotta": "laym teracottah",
  "block.minecraft.pink_terracotta": "pinky teracottah",
  "block.minecraft.gray_terracotta": "greyh teracottah",
  "block.minecraft.light_gray_terracotta": "lite greyh teracottah",
  "block.minecraft.cyan_terracotta": "nyan teracottah",
  "block.minecraft.purple_terracotta": "parpal teracottah",
  "block.minecraft.blue_terracotta": "bloo terrakattah",
  "block.minecraft.brown_terracotta": "brewn terrakattah",
  "block.minecraft.green_terracotta": "gren teracottah",
  "block.minecraft.red_terracotta": "reddish teracottah",
  "block.minecraft.black_terracotta": "blak teracottah",
  "block.minecraft.barrier": "you shall not pass",
  "block.minecraft.iron_trapdoor": "trappy irun kitty dore",
  "block.minecraft.hay_block": "stwaw bael",
  "block.minecraft.white_carpet": "white scratchy stuff",
  "block.minecraft.orange_carpet": "ornge cat rug",
  "block.minecraft.magenta_carpet": "majenta cat rug",
  "block.minecraft.light_blue_carpet": "lite bloo cat rug",
  "block.minecraft.yellow_carpet": "yello cat rug",
  "block.minecraft.lime_carpet": "limd cat rug",
  "block.minecraft.pink_carpet": "pinky cat rug",
  "block.minecraft.gray_carpet": "gray cat rug",
  "block.minecraft.light_gray_carpet": "lite gray cat rug",
  "block.minecraft.cyan_carpet": "sighun cat rug",
  "block.minecraft.purple_carpet": "parpal cat rug",
  "block.minecraft.blue_carpet": "bloo cat rug",
  "block.minecraft.brown_carpet": "brownish cat rug",
  "block.minecraft.green_carpet": "greenish cat rug",
  "block.minecraft.red_carpet": "redish cat rug",
  "block.minecraft.black_carpet": "black cat rug",
  "block.minecraft.terracotta": "terrakattah",
  "block.minecraft.coal_block": "koala",
  "block.minecraft.packed_ice": "pack'd frozen water",
  "block.minecraft.acacia_stairs": "acaci stairz",
  "block.minecraft.dark_oak_stairs": "dakwoak stairz",
  "block.minecraft.slime_block": "bouncy green stuff",
  "block.minecraft.grass_path": "gr's peth",
  "block.minecraft.sunflower": "rly tall flowr",
  "block.minecraft.lilac": "tall purpl flowr",
  "block.minecraft.rose_bush": "rose brah",
  "block.minecraft.peony": "pony plant",
  "block.minecraft.tall_grass": "tall gras",
  "block.minecraft.large_fern": "larg furn",
  "block.minecraft.white_stained_glass": "wite staind glas",
  "block.minecraft.orange_stained_glass": "oranz staned glas",
  "block.minecraft.magenta_stained_glass": "magentar stainedlyd glazz",
  "block.minecraft.light_blue_stained_glass": "lit bloo staned glas",
  "block.minecraft.yellow_stained_glass": "yelo staned glas",
  "block.minecraft.lime_stained_glass": "lim staned glas",
  "block.minecraft.pink_stained_glass": "pingk staned glas",
  "block.minecraft.gray_stained_glass": "grayly stainedly glazz",
  "block.minecraft.light_gray_stained_glass": "lightly grayen stainedly grazz",
  "block.minecraft.cyan_stained_glass": "cyanled stainely glazz",
  "block.minecraft.purple_stained_glass": "purply stainedly glazz",
  "block.minecraft.blue_stained_glass": "waterly stained glazz",
  "block.minecraft.brown_stained_glass": "brownly stainedly glazz",
  "block.minecraft.green_stained_glass": "grean stainedly glazz",
  "block.minecraft.red_stained_glass": "read stainedly glazz",
  "block.minecraft.black_stained_glass": "blak staind glas",
  "block.minecraft.white_stained_glass_pane": "whitty glazz payn",
  "block.minecraft.orange_stained_glass_pane": "oranz staned glas pan",
  "block.minecraft.magenta_stained_glass_pane": "majenta staned glas pan",
  "block.minecraft.light_blue_stained_glass_pane": "lit bloo staned glas pan",
  "block.minecraft.yellow_stained_glass_pane": "yelo staned glas pan",
  "block.minecraft.lime_stained_glass_pane": "lim staned glas pan",
  "block.minecraft.pink_stained_glass_pane": "pingk staned glas pan",
  "block.minecraft.gray_stained_glass_pane": "gray staned glas pan",
  "block.minecraft.light_gray_stained_glass_pane": "lit gray staned glas pan",
  "block.minecraft.cyan_stained_glass_pane": "sian staned glas pan",
  "block.minecraft.purple_stained_glass_pane": "parpal staned glas pan",
  "block.minecraft.blue_stained_glass_pane": "bloo staned glas pan",
  "block.minecraft.brown_stained_glass_pane": "broun staned glas pan",
  "block.minecraft.green_stained_glass_pane": "green staned glas pan",
  "block.minecraft.red_stained_glass_pane": "rud thin culurd thingy",
  "block.minecraft.black_stained_glass_pane": "blerk thin culurd thingy",
  "block.minecraft.prismarine": "prizmarine",
  "block.minecraft.prismarine_bricks": "prizmarine briks",
  "block.minecraft.dark_prismarine": "dark prizmarine",
  "block.minecraft.prismarine_stairs": "prizmarine thingy",
  "block.minecraft.prismarine_brick_stairs": "prizrin strs",
  "block.minecraft.dark_prismarine_stairs": "dark prizmarine stairz",
  "block.minecraft.sea_lantern": "see lanturn",
  "block.minecraft.red_sandstone": "warmy sanstown",
  "block.minecraft.chiseled_red_sandstone": "chizald warmy sanstown",
  "block.minecraft.cut_red_sandstone": "warmy red sanstown",
  "block.minecraft.red_sandstone_stairs": "rds litterbox sters",
  "block.minecraft.repeating_command_block": "again doing block",
  "block.minecraft.chain_command_block": "alpha block dat duz a congo line with other alpha blocks",
  "block.minecraft.magma_block": "hot bluk",
  "block.minecraft.nether_wart_block": "nether warz bluk",
  "block.minecraft.warped_wart_block": "warpt pimpl blawk",
  "block.minecraft.red_nether_bricks": "blud nezer brik",
  "block.minecraft.bone_block": "compresd bone",
  "block.minecraft.structure_void": "blank space",
  "block.minecraft.observer": "creepy stalker dude",
  "block.minecraft.shulker_box": "shulker bux",
  "block.minecraft.white_shulker_box": "waite shulker bux",
  "block.minecraft.orange_shulker_box": "ornge shulker bux",
  "block.minecraft.magenta_shulker_box": "majenta shulker bux",
  "block.minecraft.light_blue_shulker_box": "lite blue shulker bux",
  "block.minecraft.yellow_shulker_box": "yello shulker bux",
  "block.minecraft.lime_shulker_box": "limd shulker bux",
  "block.minecraft.pink_shulker_box": "pinky shulker bux",
  "block.minecraft.gray_shulker_box": "grayish shulker bux",
  "block.minecraft.light_gray_shulker_box": "lite gray shulker bux",
  "block.minecraft.cyan_shulker_box": "weird blu shulker bux",
  "block.minecraft.purple_shulker_box": "parpal shulker bux",
  "block.minecraft.blue_shulker_box": "bloo shulker bux",
  "block.minecraft.brown_shulker_box": "brownish shulker bux",
  "block.minecraft.green_shulker_box": "greenish shulker bux",
  "block.minecraft.red_shulker_box": "redish shulker bux",
  "block.minecraft.black_shulker_box": "black shulker bux",
  "block.minecraft.white_glazed_terracotta": "wayte mosaic",
  "block.minecraft.orange_glazed_terracotta": "orang mosaic",
  "block.minecraft.magenta_glazed_terracotta": "majentah mosaic",
  "block.minecraft.light_blue_glazed_terracotta": "layte bluu mosaic",
  "block.minecraft.yellow_glazed_terracotta": "yellow mosaic",
  "block.minecraft.lime_glazed_terracotta": "layme mosaic",
  "block.minecraft.pink_glazed_terracotta": "pinkyyy mosaic",
  "block.minecraft.gray_glazed_terracotta": "grey mosaic",
  "block.minecraft.light_gray_glazed_terracotta": "layte grey mosaic",
  "block.minecraft.cyan_glazed_terracotta": "syan mosaic",
  "block.minecraft.purple_glazed_terracotta": "perpl mosaic",
  "block.minecraft.blue_glazed_terracotta": "bluu mosaic",
  "block.minecraft.brown_glazed_terracotta": "brownish mosaic",
  "block.minecraft.green_glazed_terracotta": "gren mosaic",
  "block.minecraft.red_glazed_terracotta": "redish mosaic",
  "block.minecraft.black_glazed_terracotta": "blek mosaic",
  "block.minecraft.white_concrete": "wyte tough bluk",
  "block.minecraft.orange_concrete": "orang tough bluk",
  "block.minecraft.magenta_concrete": "majenta tough bluk",
  "block.minecraft.light_blue_concrete": "layte bluu tough bluk",
  "block.minecraft.yellow_concrete": "yello tough bluk",
  "block.minecraft.lime_concrete": "layme tough bluk",
  "block.minecraft.pink_concrete": "pinkyyy tough bluk",
  "block.minecraft.gray_concrete": "grey tough bluk",
  "block.minecraft.light_gray_concrete": "layte grey tough bluk",
  "block.minecraft.cyan_concrete": "syan tough bluk",
  "block.minecraft.purple_concrete": "perpl tough bluk",
  "block.minecraft.blue_concrete": "bluu tough bluk",
  "block.minecraft.brown_concrete": "brownish tough bluk",
  "block.minecraft.green_concrete": "gren tough bluk",
  "block.minecraft.red_concrete": "redish tough bluk",
  "block.minecraft.black_concrete": "blek tough bluk",
  "block.minecraft.white_concrete_powder": "wayte tough bluk powdr",
  "block.minecraft.orange_concrete_powder": "orang tough bluk powdr",
  "block.minecraft.magenta_concrete_powder": "majentah tough bluk powdr",
  "block.minecraft.light_blue_concrete_powder": "layte bluu tough bluk powdr",
  "block.minecraft.yellow_concrete_powder": "yellow tough bluk powdr",
  "block.minecraft.lime_concrete_powder": "layme tough bluk powdr",
  "block.minecraft.pink_concrete_powder": "pinkyyy tough bluk powdr",
  "block.minecraft.gray_concrete_powder": "grey tough bluk powdr",
  "block.minecraft.light_gray_concrete_powder": "layte grey tough bluk powdr",
  "block.minecraft.cyan_concrete_powder": "syan tough bluk powdr",
  "block.minecraft.purple_concrete_powder": "perpl tough bluk powdr",
  "block.minecraft.blue_concrete_powder": "bluu tough bluk powdr",
  "block.minecraft.brown_concrete_powder": "brownish tough bluk powdr",
  "block.minecraft.green_concrete_powder": "gren tough bluk powdr",
  "block.minecraft.red_concrete_powder": "redish tough bluk powdr",
  "block.minecraft.black_concrete_powder": "blak tough bluk powdr",
  "block.minecraft.turtle_egg": "tertl ball",
  "block.minecraft.dead_tube_coral_block": "ded tuf koral cube",
  "block.minecraft.dead_brain_coral_block": "ded brain koral cube",
  "block.minecraft.dead_bubble_coral_block": "ded bubol koral cube",
  "block.minecraft.dead_fire_coral_block": "ded hot koral cube",
  "block.minecraft.dead_horn_coral_block": "ded jorn koral cube",
  "block.minecraft.tube_coral_block": "tuf koral cube",
  "block.minecraft.brain_coral_block": "brein koral cube",
  "block.minecraft.bubble_coral_block": "bubol koral cube",
  "block.minecraft.fire_coral_block": "hot coral cube",
  "block.minecraft.horn_coral_block": "jorn koral cube",
  "block.minecraft.tube_coral": "tuf koral",
  "block.minecraft.brain_coral": "brein koral",
  "block.minecraft.bubble_coral": "bubol koral",
  "block.minecraft.fire_coral": "hot koral",
  "block.minecraft.horn_coral": "jorn koral",
  "block.minecraft.dead_brain_coral": "ded brein koral",
  "block.minecraft.dead_bubble_coral": "ded bubol koral",
  "block.minecraft.dead_fire_coral": "ded hot koral",
  "block.minecraft.dead_horn_coral": "ded jorn koral",
  "block.minecraft.dead_tube_coral": "ded tuf koral",
  "block.minecraft.tube_coral_fan": "tuf koral fen",
  "block.minecraft.brain_coral_fan": "brein koral fen",
  "block.minecraft.bubble_coral_fan": "bubol koral fen",
  "block.minecraft.fire_coral_fan": "hot koral fen",
  "block.minecraft.horn_coral_fan": "jorn koral fen",
  "block.minecraft.dead_tube_coral_fan": "ded tuf koral fen",
  "block.minecraft.dead_brain_coral_fan": "ded brein koral fen",
  "block.minecraft.dead_bubble_coral_fan": "ded bubol koral fen",
  "block.minecraft.dead_fire_coral_fan": "ded hot koral fen",
  "block.minecraft.dead_horn_coral_fan": "ded jorn koral fen",
  "block.minecraft.blue_ice": "big blu",
  "block.minecraft.conduit": "strange box",
  "block.minecraft.polished_granite_stairs": "pretteh red rock stairz",
  "block.minecraft.smooth_red_sandstone_stairs": "smooth redy sandston stairz",
  "block.minecraft.mossy_stone_brick_stairs": "mossy ston brik stairz",
  "block.minecraft.polished_diorite_stairs": "pretteh diorito stairz",
  "block.minecraft.mossy_cobblestone_stairs": "mossy cobulston stairz",
  "block.minecraft.end_stone_brick_stairs": "ston stairz of za end",
  "block.minecraft.stone_stairs": "ston stairz",
  "block.minecraft.smooth_sandstone_stairs": "smooth sandston stairz",
  "block.minecraft.smooth_quartz_stairs": "smooth qwartz stairz",
  "block.minecraft.granite_stairs": "red rock stairz",
  "block.minecraft.andesite_stairs": "grey rock stairz",
  "block.minecraft.red_nether_brick_stairs": "red nether brik sters",
  "block.minecraft.polished_andesite_stairs": "pretteh grey rock stairz",
  "block.minecraft.diorite_stairs": "diorito stairz",
  "block.minecraft.polished_granite_slab": "pretteh red rock sleb",
  "block.minecraft.smooth_red_sandstone_slab": "smooth redy sandston sleb",
  "block.minecraft.mossy_stone_brick_slab": "mossy ston brick sleb",
  "block.minecraft.polished_diorite_slab": "pretteh diorito sleb",
  "block.minecraft.mossy_cobblestone_slab": "mossy cobulston sleb",
  "block.minecraft.end_stone_brick_slab": "ston brik sleb of za end",
  "block.minecraft.smooth_sandstone_slab": "smooth sandston sleb",
  "block.minecraft.smooth_quartz_slab": "smooth qwartz sleb",
  "block.minecraft.granite_slab": "red rock sleb",
  "block.minecraft.andesite_slab": "grey rock",
  "block.minecraft.red_nether_brick_slab": "red sleb that nevah bricks",
  "block.minecraft.polished_andesite_slab": "pretteh grey rock sleb",
  "block.minecraft.diorite_slab": "diorito sleb",
  "block.minecraft.scaffolding": "sceffolding",
  "block.minecraft.iron_door": "iron dor",
  "block.minecraft.oak_door": "oak dor",
  "block.minecraft.spruce_door": "spruz dor",
  "block.minecraft.birch_door": "birtch dor",
  "block.minecraft.jungle_door": "jungl dor",
  "block.minecraft.acacia_door": "acashuh dor",
  "block.minecraft.dark_oak_door": "dark oak dor",
  "block.minecraft.crimson_door": "krimzn big kat door",
  "block.minecraft.warped_door": "warpt big kat door",
  "block.minecraft.repeater": "redstone repeetah",
  "block.minecraft.comparator": "redstone thingy",
  "block.minecraft.structure_block": "strcter blek",
  "block.minecraft.jigsaw": "jig saw blok",
  "item.minecraft.turtle_helmet": "tortl head□□wen unn kit-cat hed:□+2 armur",
  "item.minecraft.scute": "pice ov tutrl shell",
  "item.minecraft.iron_shovel": "iron shaval□□wehn in maen paw:□+3.5 attak damige□-3 attak faztnes",
  "item.minecraft.iron_pickaxe": "iron pikakse□□wehn in maen paw:□+3 attak damige□-2.8 attak faztnes",
  "item.minecraft.iron_axe": "iron aks□□wehn in maen paw:□+8 attak damige□-3.1 attak faztnes",
  "item.minecraft.flint_and_steel": "frint und steal",
  "item.minecraft.apple": "mapple",
  "item.minecraft.bow": "bowz",
  "item.minecraft.arrow": "errow",
  "item.minecraft.coal": "ur present",
  "item.minecraft.charcoal": "burned w00d",
  "item.minecraft.diamond": "ooooh shineee!",
  "item.minecraft.iron_ingot": "irun ingot",
  "item.minecraft.gold_ingot": "gulden ingut",
  "item.minecraft.netherite_ingot": "op ingut",
  "item.minecraft.netherite_scrap": "netherit skrapz",
  "item.minecraft.iron_sword": "irun sowrd□□wehn in maen paw:□+5 attak damige□-2.4 attak faztnes",
  "item.minecraft.wooden_sword": "wuddn sord□□wehn in maen paw:□+3 attak damige□-2.4 attak faztnes",
  "item.minecraft.wooden_shovel": "wuddn shuvl□□wehn in maen paw:□+1.5 attak damige□-3 attak faztnes",
  "item.minecraft.wooden_pickaxe": "wuddn pikkatt□□wehn in maen paw:□+1 attak damige□-2.8 attak faztnes",
  "item.minecraft.wooden_axe": "teh furst chopper□□wehn in maen paw:□+6 attak damige□-3.2 attak faztnes",
  "item.minecraft.stone_sword": "pointy rock□□wehn in maen paw:□+4 attak damige□-2.4 attak faztnes",
  "item.minecraft.stone_shovel": "stone spoon□□wehn in maen paw:□+2.5 attak damige□-3 attak faztnes",
  "item.minecraft.stone_pickaxe": "ston pikkatt□□wehn in maen paw:□+2 attak damige□-2.8 attak faztnes",
  "item.minecraft.stone_axe": "ston akx□□wehn in maen paw:□+8 attak damige□-3.2 attak faztnes",
  "item.minecraft.diamond_sword": "shiny sord□□wehn in maen paw:□+6 attak damige□-2.4 attak faztnes",
  "item.minecraft.diamond_shovel": "dimand spoon□□wehn in maen paw:□+4.5 attak damige□-3 attak faztnes",
  "item.minecraft.diamond_pickaxe": "dimand pikakse□□wehn in maen paw:□+4 attak damige□-2.8 attak faztnes",
  "item.minecraft.diamond_axe": "dimand aks□□wehn in maen paw:□+8 attak damige□-3 attak faztnes",
  "item.minecraft.stick": "stik",
  "item.minecraft.bowl": "boul",
  "item.minecraft.mushroom_stew": "a supe of funges",
  "item.minecraft.golden_sword": "goldan sord□□wehn in maen paw:□+3 attak damige□-2.4 attak faztnes",
  "item.minecraft.golden_shovel": "goldan shaval□□wehn in maen paw:□+1.5 attak damige□-3 attak faztnes",
  "item.minecraft.golden_pickaxe": "goldan pikakse□□wehn in maen paw:□+1 attak damige□-2.8 attak faztnes",
  "item.minecraft.golden_axe": "goldan aks□□wehn in maen paw:□+6 attak damige□-3 attak faztnes",
  "item.minecraft.netherite_sword": "op swurd□□wehn in maen paw:□+7 attak damige□-2.4 attak faztnes",
  "item.minecraft.netherite_shovel": "op shuvl□□wehn in maen paw:□+5.5 attak damige□-3 attak faztnes",
  "item.minecraft.netherite_pickaxe": "op pikax□□wehn in maen paw:□+5 attak damige□-2.8 attak faztnes",
  "item.minecraft.netherite_axe": "op ax□□wehn in maen paw:□+9 attak damige□-3 attak faztnes",
  "item.minecraft.string": "can i haz teh tail thing",
  "item.minecraft.feather": "dether",
  "item.minecraft.gunpowder": "ganpowder",
  "item.minecraft.wooden_hoe": "wuddn hoe□□wehn in maen paw:□-3 attak faztnes",
  "item.minecraft.stone_hoe": "ston hoe□□wehn in maen paw:□-2 attak faztnes",
  "item.minecraft.iron_hoe": "irun hoe□□wehn in maen paw:□-1 attak faztnes",
  "item.minecraft.diamond_hoe": "deemond hoe□□wehn in maen paw:",
  "item.minecraft.golden_hoe": "goldn hoe□□wehn in maen paw:□-3 attak faztnes",
  "item.minecraft.netherite_hoe": "omg no pls no y u do dis srusly stahp□□wehn in maen paw:",
  "item.minecraft.wheat_seeds": "wit seeds",
  "item.minecraft.wheat": "weet",
  "item.minecraft.bread": "bred",
  "item.minecraft.leather_helmet": "lethur kap□□wen unn kit-cat hed:□+1 armur",
  "item.minecraft.leather_chestplate": "lethur jackett□□wen un kit-cat bodi:□+3 armur",
  "item.minecraft.leather_leggings": "lethur pantz□□wen un paws:□+2 armur",
  "item.minecraft.leather_boots": "lethur butz□□wehn un bak pawz:□+1 armur",
  "item.minecraft.chainmail_helmet": "blinghat□□wen unn kit-cat hed:□+2 armur",
  "item.minecraft.chainmail_chestplate": "blinng chehst□□wen un kit-cat bodi:□+5 armur",
  "item.minecraft.chainmail_leggings": "bling pantz□□wen un paws:□+4 armur",
  "item.minecraft.chainmail_boots": "cliky fast bootz1!□□wehn un bak pawz:□+1 armur",
  "item.minecraft.iron_helmet": "irunhat□□wen unn kit-cat hed:□+2 armur",
  "item.minecraft.iron_chestplate": "irun vesst□□wen un kit-cat bodi:□+6 armur",
  "item.minecraft.iron_leggings": "irun pantz□□wen un paws:□+5 armur",
  "item.minecraft.iron_boots": "irun shoes□□wehn un bak pawz:□+2 armur",
  "item.minecraft.diamond_helmet": "very shiny hat□□wen unn kit-cat hed:□+3 armur□+2 armur fatness",
  "item.minecraft.diamond_chestplate": "super cool shirt□□wen un kit-cat bodi:□+8 armur□+2 armur fatness",
  "item.minecraft.diamond_leggings": "amazing pants□□wen un paws:□+6 armur□+2 armur fatness",
  "item.minecraft.diamond_boots": "awesome shoes□□wehn un bak pawz:□+3 armur□+2 armur fatness",
  "item.minecraft.golden_helmet": "gulden hat□□wen unn kit-cat hed:□+2 armur",
  "item.minecraft.golden_chestplate": "golden chesplaet□□wen un kit-cat bodi:□+5 armur",
  "item.minecraft.golden_leggings": "gold patnz□□wen un paws:□+3 armur",
  "item.minecraft.golden_boots": "guld bootz□□wehn un bak pawz:□+1 armur",
  "item.minecraft.netherite_helmet": "op hat□□wen unn kit-cat hed:□+3 armur□+3 armur fatness□+1 nockback rezistance",
  "item.minecraft.netherite_chestplate": "op sweatur□□wen un kit-cat bodi:□+8 armur□+3 armur fatness□+1 nockback rezistance",
  "item.minecraft.netherite_leggings": "op pantz□□wen un paws:□+6 armur□+3 armur fatness□+1 nockback rezistance",
  "item.minecraft.netherite_boots": "op shoez□□wehn un bak pawz:□+3 armur□+3 armur fatness□+1 nockback rezistance",
  "item.minecraft.flint": "sharpy rock",
  "item.minecraft.porkchop": "rawr pig",
  "item.minecraft.cooked_porkchop": "toasted piggeh",
  "item.minecraft.painting": "art on a paper",
  "item.minecraft.golden_apple": "guld apel",
  "item.minecraft.enchanted_golden_apple": "glowy power apl",
  "block.minecraft.oak_sign": "ook sign",
  "block.minecraft.spruce_sign": "sproos sign",
  "block.minecraft.birch_sign": "burchs sign",
  "block.minecraft.jungle_sign": "junglz sign",
  "block.minecraft.acacia_sign": "acashuh sign",
  "block.minecraft.dark_oak_sign": "dak ook sign",
  "block.minecraft.crimson_sign": "krimzn syne",
  "block.minecraft.warped_sign": "warpt texxt bawrd",
  "item.minecraft.bucket": "shiny sit-in cold thing",
  "item.minecraft.water_bucket": "watr buket",
  "item.minecraft.lava_bucket": "bukkit full of hot sauce",
  "item.minecraft.minecart": "minecat",
  "item.minecraft.saddle": "sad-le :c",
  "item.minecraft.redstone": "redstone dust",
  "item.minecraft.snowball": "cold wet",
  "item.minecraft.oak_boat": "ouk watr car",
  "item.minecraft.leather": "lethur",
  "item.minecraft.milk_bucket": "mikk buket!!!",
  "item.minecraft.pufferfish_bucket": "pafforfosh buket!!!",
  "item.minecraft.salmon_bucket": "salmon buket!!!",
  "item.minecraft.cod_bucket": "cot buket",
  "item.minecraft.tropical_fish_bucket": "weird water thing buket!!!",
  "item.minecraft.brick": "burned clay",
  "item.minecraft.clay_ball": "cley prom",
  "block.minecraft.dried_kelp_block": "smoky lettuce cube",
  "item.minecraft.paper": "papyrus",
  "item.minecraft.book": "book",
  "item.minecraft.slime_ball": "boogerz",
  "item.minecraft.chest_minecart": "minecat wif cat box",
  "item.minecraft.furnace_minecart": "minecat wif hot box",
  "item.minecraft.egg": "eg",
  "item.minecraft.compass": "spinny thing",
  "item.minecraft.fishing_rod": "kitteh feedin' device",
  "item.minecraft.clock": "tiem tellur",
  "item.minecraft.glowstone_dust": "glowstone duzt",
  "item.minecraft.cod": "roh cod",
  "item.minecraft.salmon": "rawr pink nomz",
  "item.minecraft.tropical_fish": "weird water thing",
  "item.minecraft.pufferfish": "very yukky fishy",
  "item.minecraft.cooked_cod": "cookd cod",
  "item.minecraft.cooked_salmon": "crisp pink nomz",
  "item.minecraft.ink_sac": "squirty nasty stuff",
  "item.minecraft.red_dye": "mojang powder",
  "item.minecraft.green_dye": "grass powder",
  "item.minecraft.cocoa_beans": "itz poop",
  "item.minecraft.lapis_lazuli": "blu stuffz",
  "item.minecraft.purple_dye": "sorta-in-between powder",
  "item.minecraft.cyan_dye": "sky powder",
  "item.minecraft.light_gray_dye": "dull powder",
  "item.minecraft.gray_dye": "moar dull powder",
  "item.minecraft.pink_dye": "less warmy powder",
  "item.minecraft.lime_dye": "nasty powder",
  "item.minecraft.yellow_dye": "banana powder",
  "item.minecraft.light_blue_dye": "wet powder",
  "item.minecraft.magenta_dye": "warmish powder",
  "item.minecraft.orange_dye": "bright powder",
  "item.minecraft.bone_meal": "smashed skeletun",
  "item.minecraft.blue_dye": "water powder",
  "item.minecraft.brown_dye": "chocolate powder",
  "item.minecraft.black_dye": "ender powder",
  "item.minecraft.white_dye": "blank powder",
  "item.minecraft.bone": "doggy treetz",
  "item.minecraft.sugar": "switz",
  "block.minecraft.cake": "liez",
  "block.minecraft.white_bed": "waite bed",
  "block.minecraft.orange_bed": "orang bed",
  "block.minecraft.magenta_bed": "majenta bed",
  "block.minecraft.light_blue_bed": "lite blu bed",
  "block.minecraft.yellow_bed": "banana bed",
  "block.minecraft.lime_bed": "limeh bed",
  "block.minecraft.pink_bed": "pinky bed",
  "block.minecraft.gray_bed": "greyh bed",
  "block.minecraft.light_gray_bed": "lite grehy bed",
  "block.minecraft.cyan_bed": "nyan bed",
  "block.minecraft.purple_bed": "parpal bed",
  "block.minecraft.blue_bed": "bloo bed",
  "block.minecraft.brown_bed": "brownish bed",
  "block.minecraft.green_bed": "gren bed",
  "block.minecraft.red_bed": "reddish bed",
  "block.minecraft.black_bed": "blak bed",
  "item.minecraft.cookie": "acookeh",
  "item.minecraft.filled_map": "direction papeh□#0",
  "item.minecraft.shears": "skizzors",
  "item.minecraft.melon_slice": "melon sliz",
  "item.minecraft.dried_kelp": "crunchy sea leaves",
  "item.minecraft.pumpkin_seeds": "pumpkez sedz",
  "item.minecraft.melon_seeds": "melan seds",
  "item.minecraft.beef": "spotty meet",
  "item.minecraft.cooked_beef": "bad spotty meet",
  "item.minecraft.chicken": "raw cluck",
  "item.minecraft.cooked_chicken": "cooked cluck",
  "item.minecraft.rotten_flesh": "taestz laik brokali",
  "item.minecraft.ender_pearl": "magic ball",
  "item.minecraft.blaze_rod": "blayz rawd",
  "item.minecraft.ghast_tear": "ghast tear",
  "item.minecraft.gold_nugget": "shineh bawl",
  "item.minecraft.nether_wart": "icky nether plant",
  "item.minecraft.potion": "poshun u cann onli gat in hax mode□no effects to dis cat",
  "item.minecraft.glass_bottle": "glas botul",
  "item.minecraft.spider_eye": "spider bal",
  "item.minecraft.fermented_spider_eye": "bad spider bal",
  "item.minecraft.blaze_powder": "blayz powder",
  "item.minecraft.magma_cream": "flamin creem",
  "block.minecraft.brewing_stand": "bubbleh",
  "block.minecraft.cauldron": "rly big pot",
  "item.minecraft.ender_eye": "teh evil eye",
  "item.minecraft.glistering_melon_slice": "glistrin melooon sliz",
  "item.minecraft.bat_spawn_egg": "bad spon ec",
  "item.minecraft.bee_spawn_egg": "b spon ec",
  "item.minecraft.blaze_spawn_egg": "bleze spon ec",
  "item.minecraft.cat_spawn_egg": "kitty cat spon ec",
  "item.minecraft.cave_spider_spawn_egg": "cavspaydur spon ec",
  "item.minecraft.chicken_spawn_egg": "nugget spon ec",
  "item.minecraft.cod_spawn_egg": "cot spon ec",
  "item.minecraft.cow_spawn_egg": "milk-maeker spon ec",
  "item.minecraft.creeper_spawn_egg": "cwepuh spon ec",
  "item.minecraft.dolphin_spawn_egg": "doolfin spon ec",
  "item.minecraft.donkey_spawn_egg": "danky spon ec",
  "item.minecraft.drowned_spawn_egg": "drawn spon ec",
  "item.minecraft.elder_guardian_spawn_egg": "ehldur gardien spon ec",
  "item.minecraft.enderman_spawn_egg": "endrmen spon ec",
  "item.minecraft.endermite_spawn_egg": "endrmit spon ec",
  "item.minecraft.evoker_spawn_egg": "evokr spon ec",
  "item.minecraft.fox_spawn_egg": "fuxe spon ec",
  "item.minecraft.ghast_spawn_egg": "gast spon ec",
  "item.minecraft.guardian_spawn_egg": "gardien spon ec",
  "item.minecraft.hoglin_spawn_egg": "boar vessel, 600-500 bc etruscan ceramic span ec",
  "item.minecraft.horse_spawn_egg": "hors spon ec",
  "item.minecraft.husk_spawn_egg": "hask spon ec",
  "item.minecraft.llama_spawn_egg": "lahmuh spon ec",
  "item.minecraft.magma_cube_spawn_egg": "magmuh cewb spon ec",
  "item.minecraft.mooshroom_spawn_egg": "mewshroom spon ec",
  "item.minecraft.mule_spawn_egg": "mewl spon ec",
  "item.minecraft.ocelot_spawn_egg": "oslot spon ec",
  "item.minecraft.panda_spawn_egg": "green stick eatar spon ec",
  "item.minecraft.parrot_spawn_egg": "pawet spon ec",
  "item.minecraft.phantom_spawn_egg": "fantum spon ec",
  "item.minecraft.pig_spawn_egg": "pic spon ec",
  "item.minecraft.piglin_spawn_egg": "piggen spon ec",
  "item.minecraft.pillager_spawn_egg": "pilagur spon ec",
  "item.minecraft.polar_bear_spawn_egg": "polah bar spon ec",
  "item.minecraft.pufferfish_spawn_egg": "pufahfis spon ec",
  "item.minecraft.rabbit_spawn_egg": "wabit spon ec",
  "item.minecraft.ravager_spawn_egg": "rivagur spon ec",
  "item.minecraft.salmon_spawn_egg": "samin spon ec",
  "item.minecraft.sheep_spawn_egg": "shep spon ec",
  "item.minecraft.shulker_spawn_egg": "shuker spon eg",
  "item.minecraft.silverfish_spawn_egg": "sivahfish spon eg",
  "item.minecraft.skeleton_spawn_egg": "skelehten spon ec",
  "item.minecraft.skeleton_horse_spawn_egg": "skehlehten hors span eg",
  "item.minecraft.slime_spawn_egg": "sliem spon ec",
  "item.minecraft.spider_spawn_egg": "spaydur spon ec",
  "item.minecraft.squid_spawn_egg": "sqwid spon ec",
  "item.minecraft.stray_spawn_egg": "strey spon ec",
  "item.minecraft.strider_spawn_egg": "straydur spon ec",
  "item.minecraft.trader_llama_spawn_egg": "givr camel spon ec",
  "item.minecraft.tropical_fish_spawn_egg": "trahpicul fish spon ec",
  "item.minecraft.turtle_spawn_egg": "tortl spon ec",
  "item.minecraft.vex_spawn_egg": "vax spon ec",
  "item.minecraft.villager_spawn_egg": "vilagur spon ec",
  "item.minecraft.vindicator_spawn_egg": "vindahcaytur spon ec",
  "item.minecraft.wandering_trader_spawn_egg": "wubterng truder spon ec",
  "item.minecraft.witch_spawn_egg": "wetch spon ec",
  "item.minecraft.wither_skeleton_spawn_egg": "widah skelehten spon ec",
  "item.minecraft.wolf_spawn_egg": "wuf spon ec",
  "item.minecraft.zoglin_spawn_egg": "ded hog spwn eg",
  "item.minecraft.zombie_spawn_egg": "zobi spon ec",
  "item.minecraft.zombie_horse_spawn_egg": "zobi horz spon ec",
  "item.minecraft.zombie_villager_spawn_egg": "zobi pegmen spon ec",
  "item.minecraft.zombified_piglin_spawn_egg": "zobifyed pyglinn spon ec",
  "item.minecraft.experience_bottle": "potion wif ur levlz",
  "item.minecraft.fire_charge": "fire punch!",
  "item.minecraft.writable_book": "nerd!",
  "item.minecraft.written_book": "book 4 reeding",
  "item.minecraft.emerald": "shineh green stuff",
  "item.minecraft.item_frame": "kitteh fraem",
  "block.minecraft.flower_pot": "container for all the pretty plantz",
  "item.minecraft.carrot": "rebbit treetz",
  "item.minecraft.potato": "pootato",
  "item.minecraft.baked_potato": "bak'd pootato",
  "item.minecraft.poisonous_potato": "no eat iz yukky",
  "item.minecraft.map": "cleen map",
  "item.minecraft.golden_carrot": "gulden carrut",
  "block.minecraft.skeleton_skull": "spooke scury skeletun faze",
  "block.minecraft.wither_skeleton_skull": "wither skellyton skul",
  "block.minecraft.player_head": "kat hed",
  "block.minecraft.zombie_head": "zombee hed",
  "block.minecraft.creeper_head": "creeper hed",
  "block.minecraft.dragon_head": "dragun hed",
  "item.minecraft.carrot_on_a_stick": "yummy food on stik",
  "item.minecraft.warped_fungus_on_a_stick": "warpt foongis on a stick",
  "item.minecraft.nether_star": "nether asterisk",
  "item.minecraft.pumpkin_pie": "pie with squash in it",
  "item.minecraft.firework_rocket": "shiny 'splody thing",
  "item.minecraft.firework_star": "dis makes da rocket go boom boom",
  "item.minecraft.enchanted_book": "shineh magic book",
  "item.minecraft.nether_brick": "nether brik",
  "item.minecraft.quartz": "nether cloudz",
  "item.minecraft.tnt_minecart": "boomy minecat",
  "item.minecraft.hopper_minecart": "minecat wif hoppez",
  "item.minecraft.prismarine_shard": "prizmarine thingy",
  "item.minecraft.prismarine_crystals": "prizmarine pebblez",
  "item.minecraft.rabbit": "bloody jumpin foodz",
  "item.minecraft.cooked_rabbit": "warm jumpin foodz",
  "item.minecraft.rabbit_stew": "warm jumpin foodz in bawl",
  "item.minecraft.rabbit_foot": "jumpin foodz fut",
  "item.minecraft.rabbit_hide": "jumpin foodz rag",
  "item.minecraft.armor_stand": "stick hooman",
  "item.minecraft.iron_horse_armor": "shiny hoofy fur",
  "item.minecraft.golden_horse_armor": "goden horz armar",
  "item.minecraft.diamond_horse_armor": "supah shiny hoofy fur",
  "item.minecraft.leather_horse_armor": "leathr horse armor",
  "item.minecraft.lead": "leesh",
  "item.minecraft.name_tag": "renaemer",
  "item.minecraft.command_block_minecart": "minecat wif comnd bluk",
  "item.minecraft.mutton": "bloody mutn",
  "item.minecraft.cooked_mutton": "warm mutn",
  "block.minecraft.white_banner": "blenk bahnor",
  "block.minecraft.orange_banner": "oreng bahnor",
  "block.minecraft.magenta_banner": "megentre bahnor",
  "block.minecraft.light_blue_banner": "ligt bloo bahnor",
  "block.minecraft.yellow_banner": "yelloh bahnor",
  "block.minecraft.lime_banner": "liem bahnor",
  "block.minecraft.pink_banner": "pinek bahnor",
  "block.minecraft.gray_banner": "grai bahnor",
  "block.minecraft.light_gray_banner": "ligt grai bahnor",
  "block.minecraft.cyan_banner": "nyan bahnor",
  "block.minecraft.purple_banner": "purrrpel bahnor",
  "block.minecraft.blue_banner": "bloo bahnor",
  "block.minecraft.brown_banner": "broun bahnor",
  "block.minecraft.green_banner": "grene bahnor",
  "block.minecraft.red_banner": "red bahnor",
  "block.minecraft.black_banner": "blakc bahnor",
  "item.minecraft.end_crystal": "endur cristal",
  "item.minecraft.chorus_fruit": "frute dat duznt sing",
  "item.minecraft.popped_chorus_fruit": "popped frut dat duznt sing",
  "item.minecraft.beetroot": "betrut",
  "item.minecraft.beetroot_seeds": "betrut seds",
  "item.minecraft.beetroot_soup": "betrut supe",
  "item.minecraft.dragon_breath": "dragunish puff",
  "item.minecraft.splash_potion": "spleshy poshun u cann onli gat in hax mode□no effects to dis cat",
  "item.minecraft.spectral_arrow": "shini errow",
  "item.minecraft.tipped_arrow": "shooty tihng u cann onli gat in hax mode□no effects to dis cat",
  "item.minecraft.lingering_potion": "linnerin poshun u cann onli gat in hax mode□no effects to dis cat",
  "item.minecraft.shield": "cat protecshun",
  "item.minecraft.elytra": "flyyyyyyyy",
  "item.minecraft.spruce_boat": "sproos watr car",
  "item.minecraft.birch_boat": "burch watr car",
  "item.minecraft.jungle_boat": "jungo watr car",
  "item.minecraft.acacia_boat": "akacia watr car",
  "item.minecraft.dark_oak_boat": "blak oke watr car",
  "item.minecraft.totem_of_undying": "anti-dyin' totum",
  "item.minecraft.shulker_shell": "shulker shell",
  "item.minecraft.iron_nugget": "steely thingy",
  "item.minecraft.knowledge_book": "buk of knawledg",
  "item.minecraft.debug_stick": "magik stik",
  "item.minecraft.music_disc_13": "round loud thing□c418 - 13",
  "item.minecraft.music_disc_cat": "round loud thing□c418 - cat",
  "item.minecraft.music_disc_blocks": "round loud thing□c418 - blocks",
  "item.minecraft.music_disc_chirp": "round loud thing□c418 - chirp",
  "item.minecraft.music_disc_far": "round loud thing□c418 - far",
  "item.minecraft.music_disc_mall": "round loud thing□c418 - mall",
  "item.minecraft.music_disc_mellohi": "round loud thing□c418 - mellohi",
  "item.minecraft.music_disc_stal": "round loud thing□c418 - stal",
  "item.minecraft.music_disc_strad": "round loud thing□c418 - strad",
  "item.minecraft.music_disc_ward": "round loud thing□c418 - ward",
  "item.minecraft.music_disc_11": "round loud thing□c418 - 11",
  "item.minecraft.music_disc_wait": "round loud thing□c418 - wait",
  "item.minecraft.music_disc_pigstep": "round loud thing□lena raine - pigstep",
  "item.minecraft.trident": "dinglehopper□□wehn in maen paw:□+8 attak damige□-2.9 attak faztnes",
  "item.minecraft.phantom_membrane": "creepy flyin ting mimbrain",
  "item.minecraft.nautilus_shell": "naughty shell",
  "item.minecraft.heart_of_the_sea": "hart of da see",
  "item.minecraft.crossbow": "crosbowz",
  "item.minecraft.suspicious_stew": "idk dont eat dat",
  "block.minecraft.loom": "lööm",
  "item.minecraft.flower_banner_pattern": "bannr paturn□flowerpower in charge",
  "item.minecraft.creeper_banner_pattern": "bannr paturn□creeper churge",
  "item.minecraft.skull_banner_pattern": "bannr paturn□skullz churge",
  "item.minecraft.mojang_banner_pattern": "bannr paturn□ting",
  "item.minecraft.globe_banner_pattern": "bannr paturn□glolbe",
  "item.minecraft.piglin_banner_pattern": "bannr paturn□nouze",
  "block.minecraft.composter": "compostr",
  "block.minecraft.barrel": "fish box",
  "block.minecraft.smoker": "za smoker",
  "block.minecraft.blast_furnace": "blast furnace",
  "block.minecraft.cartography_table": "cartogrophy table",
  "block.minecraft.fletching_table": "fleching tabel",
  "block.minecraft.grindstone": "removezstone",
  "block.minecraft.lectern": "book readin ting",
  "block.minecraft.smithing_table": "smissing table",
  "block.minecraft.stonecutter": "shrpy movin thingy",
  "block.minecraft.bell": "belly",
  "block.minecraft.lantern": "lanturn",
  "block.minecraft.soul_lantern": "sol lanturn",
  "item.minecraft.sweet_berries": "sweet beries",
  "block.minecraft.campfire": "campfireh",
  "block.minecraft.soul_campfire": "sul camfiri",
  "block.minecraft.shroomlight": "shroomy lite",
  "item.minecraft.honeycomb": "honyconb",
  "block.minecraft.bee_nest": "b nest",
  "block.minecraft.beehive": "beez's place",
  "item.minecraft.honey_bottle": "huny buttle",
  "block.minecraft.honey_block": "huny bloc",
  "block.minecraft.honeycomb_block": "b thing bloc",
  "block.minecraft.lodestone": "loserstone",
  "block.minecraft.netherite_block": "omg rich kitteh",
  "block.minecraft.ancient_debris": "super old stuffz",
  "block.minecraft.target": "tawget",
  "block.minecraft.crying_obsidian": "sad hardest thing evar",
  "block.minecraft.blackstone": "blecston",
  "block.minecraft.blackstone_slab": "bleckston sleb",
  "block.minecraft.blackstone_stairs": "bleck rock stairz",
  "block.minecraft.gilded_blackstone": "some goldid bleckston",
  "block.minecraft.polished_blackstone": "polised bleckston",
  "block.minecraft.polished_blackstone_slab": "shiny blak rok sleb",
  "block.minecraft.polished_blackstone_stairs": "shiny blak rok sters",
  "block.minecraft.chiseled_polished_blackstone": "chizald shiny blak rok",
  "block.minecraft.polished_blackstone_bricks": "preteh bleck rockz stackd",
  "block.minecraft.polished_blackstone_brick_slab": "shiny blak rok brik slab",
  "block.minecraft.polished_blackstone_brick_stairs": "shiny blak rok brik sters",
  "block.minecraft.cracked_polished_blackstone_bricks": "craked polised bleck briks",
  "block.minecraft.respawn_anchor": "reezpon mawgic blok",
}
export const lol_us = items; 
